/** Area-unit codes mapped to Norwegian names. */
export const biodiversityAreaUnitsNb: Record<string, string> = {
  m2: "Kvadratmeter (m²)",
  ha: "Hektar (ha)",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const biodiversityAreaUnitOptionsNb: Array<{ code: string; name: string }> = Object.entries(
  biodiversityAreaUnitsNb,
)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))
